import React, { useContext, useState } from "react";
import { Modal, Button, Form, Spinner, Alert } from "react-bootstrap";
import ReportsService from "../../../../../../../services/reports-service";
import { IdentityContext } from "../../../../../../../context/identity-context";

const RejectModal = ({ show, handleClose, report }) => {
  const [rejectionReason, setRejectionReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const reportsService = new ReportsService();
  const { user } = useContext(IdentityContext);

  const handleSubmit = async () => {
    if (!rejectionReason.trim()) {
      setError("Please specify the changes needed.");
      return;
    }
    
    setLoading(true);
    setError(null);
    
    try {
      await reportsService.adcuCheckerRejectReport(
        report.reportHash,
        user.attributes['custom:display_name'],
        report.interestPaymentDate,
        rejectionReason
      );
      handleClose();
      window.location.reload();
    } catch (err) {
      setError(err.response?.data?.message || "Failed to reject the report. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Return Report</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <p>Selected report will be returned.</p>
        <Form>
          <Form.Group controlId="rejectionReason">
            <Form.Label>Please specify the changes that will be needed:</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              placeholder="Enter rejection reason..."
              value={rejectionReason}
              onChange={(e) => setRejectionReason(e.target.value)}
              disabled={loading}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between w-100">
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          Back
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? <Spinner as="span" animation="border" size="sm" /> : "Continue to Send"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RejectModal;